var map = {
	"./bg_b.png": "b23c",
	"./bg_f.png": "9009",
	"./bg_g.png": "7be6",
	"./bg_r.png": "a4da",
	"./bg_u.png": "05ff",
	"./bg_w.png": "d0e7",
	"./bg_z.png": "87f9"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "4b6e";